import { createTheme, responsiveFontSizes } from '@mui/material/styles';

//import lato300 from '../assets/fonts/Lato-300.ttf';

const primaryColor = '#FFAE42' //'#FF6200' // '#F1BE40'; // '#1a90ff'; //'#ED474A'; //'#F95700';
const secondaryColor = '#080708'; //'#64F58D'; //'#1a90ff';
const tertiaryColor = '#DAE0F2';
const white = '#ffffff';
//const errorColor = '#D2042D';
//const successColor = '#44AF69';
const errorColor = '#c53929';
const successColor = '#0b8043';
const grey900 = '#212121';
const grey800 = '#424242';
const grey700 = '#616161';
const grey600 = '#757575';
const grey500 = '#9e9e9e';
const grey400 = '#bdbdbd';
const grey300 = '#e0e0e0';
const grey200 = '#eeeeee';
const grey100 = '#f5f5f5';
const grey50 = '#f9f9f9';

const secondaryGrey = '#827f8f';

let theme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
      contrastText: white,
    },
    secondary: {
      main: secondaryColor,
      contrastText: white,
    }, 
    tertiary: {
      main: tertiaryColor,
      contrastText: white,
    }, 
    error: { 
      main: errorColor 
    },
    success: { 
      main: successColor 
    },
    grey: {
      900: grey900,
      800: grey800,
      700: grey700,
      600: grey600,
      500: grey500,
      400: grey400,
      300: grey300,
      200: grey200,
      100: grey100,
      50: grey50,
    },
    text: {
      primary: grey900,
      secondary: secondaryGrey,
    }
  },
  typography: {
    fontFamily: 'Metropolis',
    h2: {
      fontWeight: 800,
    },
    h3: {
      fontWeight: 900,
    },
    h4: {
      fontWeight: 900,
    },
    h5: {
      fontWeight: 800
    },
    h6: {
      fontWeight: 500
    },
    subtitle1: {
      fontWeight: 500,
    },
    body1: {
      fontWeight: 100,
    },
    body2: {
      fontSize: '13px',
      fontWeight: 100,
    },
    button: {
      textTransform: 'none',
    }
  },
  shape: {
    borderRadius: 30,
  },
  components: {
    /*MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Lato';
          font-style: normal;
          font-display: swap;
          font-weight: 300;
          src: local(${lato300});
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },*/
    /*
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: grey100,
          borderRadius: '30px',
          minWidth: 50, 
          padding: '10px',
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          borderRadius: '30px',
        },
      }
    },*/
    MuiAppBar: {
      styleOverrides: {
        root: {
          zIndex: '1000',
          color: primaryColor,
          backgroundColor: white,
          borderBottom: '1px solid' + grey200
        }
      }
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          height: '65px',
        }
      }
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          fontSize: '18px',
        },
        label: {
          fontSize: '10px',
        },
        iconOnly: {
          fontSize: '20px'
        },        
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          //padding: '5px 10px',
          minHeight: '60px',
          backgroundColor: grey50,
          '&.Mui-focused': {
            backgroundColor: white,
          },
          '& fieldset': {
            //borderColor: grey100,
            borderColor: grey200,
          },
          '&:hover fieldset': {
            borderColor: grey700,
          },
          '&.Mui-focused fieldset': {
            borderColor: primaryColor,
          },
        },
        input: {
          '&::placeholder': {
            color: grey900,
            fontWeight: '400',
          }
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          '& .MuiMenu-paper': {
            //padding: '5px',
            //boxShadow: 'rgba(0, 0, 0, 0.05) 0px 3px 24px 0px',
            boxShadow: 'rgba(0, 0, 0, 0.05) 0px 3px 24px 0px',
            //backgroundColor: grey50,
            border: '1px solid' + grey200,
            padding: '2px 0px',
          },
          '& .Mui-selected': {
            backgroundColor: grey100,
            '&:hover': {
              backgroundColor: grey100,
            }
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '30px',
          '& .MuiInputAdornment-root': {
            padding: '2px 5px 2px 5px',
          },
          '& .MuiInputLabel-root': {
            color: grey800,
            paddingTop: '1px',
            //padding: '3px',
            '&.Mui-focused': {
              color: grey900,
            },
          }
        }
      }
    },

    MuiStepIcon: {
      styleOverrides: {
        root: {
          fontSize: '40px',
          fontWeight: '700',
        }
      }
    },
    MuiStepConnector: {
      styleOverrides: {
        root: {
          padding: '9px 0px',
        }
      }
    },
    
    /*MuiStepContent: {
      styleOverrides: {
        root: {
          //padding: '0px 9px',
          //padding: '10px 20px 0px 42px',
          //margin: '0px 21px',
          fontSize: '16px'
        }
      }
    },*/
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          zIndex: '2000',
          backgroundColor: 'rgba(40, 40, 40, 0.8)',
          color: white,
          fontSize: "12px",
          padding: '3px 14px 3px 14px',
          fontWeight: 700,          
        }
      }
    },
  }
  /*
  shape: {
    borderRadius: 10,
  },
  spacing: 10,
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        color: primaryColor,
        backgroundColor: white
      }
    },
    MuiDrawer: {
      paper: {
        background: white,
        '& span': { color: primaryGrey },
        '& svg': { color: primaryColor, marginLeft: '5px' },
      },
    },
    MuiMenu: {
      paper: {
        boxShadow: 'rgba(0, 0, 0, 0.15) 0px 3px 24px 0px',
      }
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: white,
        color: primaryGrey,
        fontSize: "14px",
        fontWeight: 400,
      }
    },
    MuiSlider: {
      valueLabel:{
        fontWeight: '700',
      }
    },
    MuiFab: {
      root: {
        boxShadow: 'rgba(0, 0, 0, 0.25) 0px 3px 24px 0px',
      }
    }
  },*/
});

theme = responsiveFontSizes(theme);

export default theme;